
export default {
    name: 'ThePrice',

    props: {
        isDiscounted: {
            type: Boolean,
            default: false,
        },
        isStrikethrough: {
            type: Boolean,
            default: false,
        },
        isNormal: {
            type: Boolean,
            default: false,
        },
        price: {
            type: Number,
            default: null,
        },
    },
}
